// features/workstations/shared/shift-read.js
// ═══════════════════════════════════════════════════════════
// SHIFT'S READ — one-line italic synthesis attached to any
// AI output (dashboard sections, finding cards, knowledge
// items, learn cards). The Jarvis voice in primitive form.
//
// Variant maps to the system color semantics (see
// styles/workstation-tones.css):
//   gold   — primary intelligence read (default, most uses)
//   sage   — positive / healthy / "this is working"
//   teal   — action-flavored / "here's what to do"
//   purple — deeper synthesis / "here's the meta read"
//   terra  — risk-flavored / "watch this"
//
// Label resolution (Commit 25 — Tim's request):
//   1. explicit `label` prop wins (legacy + special-case override)
//   2. `aiName` prop → "<aiName>'s Read" (e.g. "Emily's Read")
//   3. AiNameContext value → same as (2) (no prop drilling needed)
//   4. fallback "Shift's Read" (when no user context — e.g. SSR)
//
// The Provider is exported here too so widget-card.js can wrap
// each rendered section with the resolved AI name from
// userRecord.ai_name. Section components stay clean — no need
// to thread aiName through every JSX call site.
// ═══════════════════════════════════════════════════════════

import { createContext, useContext } from 'react';

export const AiNameContext = createContext(null);

export default function ShiftRead({ children, variant = 'gold', label, aiName }) {
  const ctxAiName = useContext(AiNameContext);
  const resolvedAiName = aiName || ctxAiName;
  // Curly apostrophe (\u2019) — same typography as elsewhere in
  // the system. Matches the legacy label format exactly.
  const computedLabel = label
    || (resolvedAiName ? `${resolvedAiName}\u2019s Read` : 'Shift\u2019s Read');
  return (
    <div className={`ws-shift-read ws-shift-read-${variant}`}>
      <div className="ws-shift-read-label">{computedLabel}</div>
      <div className="ws-shift-read-text">{children}</div>
    </div>
  );
}
